var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "new-employee" }, [
    _c("h4", { staticClass: "title is-4 has-text-primary" }, [
      _vm._v("\n    Requeridos\n  ")
    ]),
    _c("div", { staticClass: "columns is-multiline" }, [
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            { attrs: { label: "Nombre", "label-for": "privateName" } },
            [
              _c("BInput", {
                attrs: {
                  id: "privateName",
                  placeholder: "Rafaeli Camposorio Ruízo",
                  icon: "account",
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  required: ""
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("name", $event)
                  }
                },
                model: {
                  value: _vm.privateName,
                  callback: function($$v) {
                    _vm.privateName = $$v
                  },
                  expression: "privateName"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            { attrs: { label: "Email", "label-for": "privateEmail" } },
            [
              _c("BInput", {
                attrs: {
                  id: "privateEmail",
                  placeholder: "correo@mail.com",
                  icon: "email",
                  type: "email",
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  required: ""
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("email", $event)
                  }
                },
                model: {
                  value: _vm.privateEmail,
                  callback: function($$v) {
                    _vm.privateEmail = $$v
                  },
                  expression: "privateEmail"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            { attrs: { label: "RFC", "label-for": "privateRfc" } },
            [
              _c("BInput", {
                attrs: {
                  id: "privateRfc",
                  placeholder: "PAL7202161U0",
                  icon: "fingerprint",
                  pattern: _vm.rfcPattern,
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  required: ""
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("rfc", $event)
                  }
                },
                model: {
                  value: _vm.privateRfc,
                  callback: function($$v) {
                    _vm.privateRfc = $$v
                  },
                  expression: "privateRfc"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            { attrs: { label: "CURP", "label-for": "privateCurp" } },
            [
              _c("BInput", {
                attrs: {
                  id: "privateCurp",
                  placeholder: "CABL840215MDFSRS01",
                  icon: "human-male",
                  pattern: _vm.curpPattern,
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  required: ""
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("curp", $event)
                  }
                },
                model: {
                  value: _vm.privateCurp,
                  callback: function($$v) {
                    _vm.privateCurp = $$v
                  },
                  expression: "privateCurp"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            {
              staticClass: "is-fullwidth",
              attrs: {
                label: "Tipo de contrato",
                "label-for": "privateContractType"
              }
            },
            [
              _c(
                "BSelect",
                {
                  staticClass: "is-fullwidth",
                  attrs: {
                    id: "privateContractType",
                    placeholder: "Selecciona el tipo de contracto",
                    disabled: _vm.loading,
                    loading: _vm.loading,
                    required: ""
                  },
                  on: {
                    input: function($event) {
                      return _vm.onInput("contractType", $event)
                    }
                  },
                  model: {
                    value: _vm.privateContractType,
                    callback: function($$v) {
                      _vm.privateContractType = $$v
                    },
                    expression: "privateContractType"
                  }
                },
                _vm._l(_vm.contractTypeCatalog, function(option) {
                  return _c(
                    "option",
                    { key: option.value, domProps: { value: option.value } },
                    [
                      _vm._v(
                        "\n            " + _vm._s(option.label) + "\n          "
                      )
                    ]
                  )
                }),
                0
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            {
              staticClass: "is-fullwidth",
              attrs: {
                label: "Tipo de régimen",
                "label-for": "privateWorkingDayType"
              }
            },
            [
              _c(
                "BSelect",
                {
                  staticClass: "is-fullwidth",
                  attrs: {
                    id: "privateRegimeType",
                    placeholder: "Selecciona el tipo de contracto",
                    disabled: _vm.loading,
                    loading: _vm.loading,
                    "is-fullwidth": "",
                    required: ""
                  },
                  on: {
                    input: function($event) {
                      return _vm.onInput("regimeType", $event)
                    }
                  },
                  model: {
                    value: _vm.privateRegimeType,
                    callback: function($$v) {
                      _vm.privateRegimeType = $$v
                    },
                    expression: "privateRegimeType"
                  }
                },
                _vm._l(_vm.regimeTypeCatalog, function(option) {
                  return _c(
                    "option",
                    { key: option.value, domProps: { value: option.value } },
                    [
                      _vm._v(
                        "\n            " + _vm._s(option.label) + "\n          "
                      )
                    ]
                  )
                }),
                0
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            {
              attrs: { label: "Código postal", "label-for": "privateZipCode" }
            },
            [
              _c("BInput", {
                attrs: {
                  id: "privateZipCode",
                  placeholder: "",
                  maxlength: "5",
                  pattern: _vm.zipCodePattern,
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  required: ""
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("zipCode", $event)
                  }
                },
                model: {
                  value: _vm.privateZipCode,
                  callback: function($$v) {
                    _vm.privateZipCode = $$v
                  },
                  expression: "privateZipCode"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _c("h4", { staticClass: "title is-4 has-text-primary" }, [
      _vm._v("\n    Opcionales\n  ")
    ]),
    _c("div", { staticClass: "columns is-multiline" }, [
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            {
              attrs: {
                label: "Número de Seguro Social",
                "label-for": "privateSocialSecurityNumber"
              }
            },
            [
              _c("BInput", {
                attrs: {
                  id: "privateSocialSecurityNumber",
                  placeholder: "123456789",
                  icon: "hospital",
                  disabled: _vm.loading,
                  loading: _vm.loading
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("socialSecurityNumber", $event)
                  }
                },
                model: {
                  value: _vm.privateSocialSecurityNumber,
                  callback: function($$v) {
                    _vm.privateSocialSecurityNumber = $$v
                  },
                  expression: "privateSocialSecurityNumber"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            {
              attrs: {
                label: "Fecha inicio laboral",
                "label-for": "privateJobRelationshipStart"
              }
            },
            [
              _c(
                "BDatepicker",
                _vm._b(
                  {
                    attrs: {
                      id: "privateJobRelationshipStart",
                      disabled: _vm.loading,
                      loading: _vm.loading,
                      icon: "calendar-import"
                    },
                    on: {
                      input: function($event) {
                        return _vm.onInput("jobRelationshipStart", $event)
                      }
                    },
                    model: {
                      value: _vm.privateJobRelationshipStart,
                      callback: function($$v) {
                        _vm.privateJobRelationshipStart = $$v
                      },
                      expression: "privateJobRelationshipStart"
                    }
                  },
                  "BDatepicker",
                  _vm.calendarProps,
                  false
                )
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            {
              attrs: { label: "Sindicalizado", "label-for": "privateUnionized" }
            },
            [
              _c(
                "div",
                { staticClass: "field has-addons unionized" },
                [
                  _vm._l(_vm.unionizedCatalog, function(unionized) {
                    return [
                      _c(
                        "BRadioButton",
                        {
                          key: unionized.key,
                          staticClass: "unionized-radiobutton",
                          attrs: {
                            name: "unionized",
                            disabled: _vm.loading,
                            loading: _vm.loading,
                            "native-value": unionized.value
                          },
                          on: {
                            input: function($event) {
                              return _vm.onInput("unionized", $event)
                            }
                          },
                          model: {
                            value: _vm.privateUnionized,
                            callback: function($$v) {
                              _vm.privateUnionized = $$v
                            },
                            expression: "privateUnionized"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(unionized.label))])]
                      )
                    ]
                  })
                ],
                2
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            {
              staticClass: "is-fullwidth",
              attrs: {
                label: "Tipo de jornada",
                "label-for": "privateWorkingDayType"
              }
            },
            [
              _c(
                "BSelect",
                {
                  staticClass: "is-fullwidth",
                  attrs: {
                    id: "privateWorkingDayType",
                    placeholder: "Selecciona el tipo de contracto",
                    disabled: _vm.loading,
                    loading: _vm.loading,
                    "is-fullwidth": ""
                  },
                  on: {
                    input: function($event) {
                      return _vm.onInput("workingDayType", $event)
                    }
                  },
                  model: {
                    value: _vm.privateWorkingDayType,
                    callback: function($$v) {
                      _vm.privateWorkingDayType = $$v
                    },
                    expression: "privateWorkingDayType"
                  }
                },
                _vm._l(_vm.workingDayTypeCatalog, function(option) {
                  return _c(
                    "option",
                    { key: option.value, domProps: { value: option.value } },
                    [
                      _vm._v(
                        "\n            " + _vm._s(option.label) + "\n          "
                      )
                    ]
                  )
                }),
                0
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            {
              attrs: {
                label: "Número de empleado",
                "label-for": "privateEmployedNumber"
              }
            },
            [
              _c("BInput", {
                attrs: {
                  id: "privateEmployedNumber",
                  disabled: _vm.loading,
                  loading: _vm.loading
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("employedNumber", $event)
                  }
                },
                model: {
                  value: _vm.privateEmployedNumber,
                  callback: function($$v) {
                    _vm.privateEmployedNumber = $$v
                  },
                  expression: "privateEmployedNumber"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            {
              attrs: { label: "Departamento", "label-for": "privateDepartment" }
            },
            [
              _c("BInput", {
                attrs: {
                  id: "privateDepartment",
                  disabled: _vm.loading,
                  loading: _vm.loading
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("department", $event)
                  }
                },
                model: {
                  value: _vm.privateDepartment,
                  callback: function($$v) {
                    _vm.privateDepartment = $$v
                  },
                  expression: "privateDepartment"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            { attrs: { label: "Posición", "label-for": "privatePosition" } },
            [
              _c("BInput", {
                attrs: {
                  id: "privatePosition",
                  disabled: _vm.loading,
                  loading: _vm.loading
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("position", $event)
                  }
                },
                model: {
                  value: _vm.privatePosition,
                  callback: function($$v) {
                    _vm.privatePosition = $$v
                  },
                  expression: "privatePosition"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            {
              attrs: {
                label: "Nivel de peligro",
                "label-for": "privateHazardPosition"
              }
            },
            [
              _c(
                "BSelect",
                {
                  staticClass: "is-fullwidth",
                  attrs: {
                    id: "privateHazardPosition",
                    placeholder: "Selecciona el tipo de contracto",
                    disabled: _vm.loading,
                    loading: _vm.loading,
                    "is-fullwidth": ""
                  },
                  on: {
                    input: function($event) {
                      return _vm.onInput("hazardPosition", $event)
                    }
                  },
                  model: {
                    value: _vm.privateHazardPosition,
                    callback: function($$v) {
                      _vm.privateHazardPosition = $$v
                    },
                    expression: "privateHazardPosition"
                  }
                },
                _vm._l(_vm.hazardPositionCatalog, function(option) {
                  return _c(
                    "option",
                    { key: option.value, domProps: { value: option.value } },
                    [
                      _vm._v(
                        "\n            " + _vm._s(option.label) + "\n          "
                      )
                    ]
                  )
                }),
                0
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            {
              attrs: {
                label: "Periodicidad del pago",
                "label-for": "privatePaymentPeriodicity"
              }
            },
            [
              _c(
                "BSelect",
                {
                  staticClass: "is-fullwidth",
                  attrs: {
                    id: "privatePaymentPeriodicity",
                    placeholder: "Selecciona el tipo de contracto",
                    disabled: _vm.loading,
                    loading: _vm.loading,
                    "is-fullwidth": ""
                  },
                  on: {
                    input: function($event) {
                      return _vm.onInput("paymentPeriodicity", $event)
                    }
                  },
                  model: {
                    value: _vm.privatePaymentPeriodicity,
                    callback: function($$v) {
                      _vm.privatePaymentPeriodicity = $$v
                    },
                    expression: "privatePaymentPeriodicity"
                  }
                },
                _vm._l(_vm.paymentPeriodicityCatalog, function(option) {
                  return _c(
                    "option",
                    { key: option.value, domProps: { value: option.value } },
                    [
                      _vm._v(
                        "\n            " + _vm._s(option.label) + "\n          "
                      )
                    ]
                  )
                }),
                0
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            { attrs: { label: "Banco", "label-for": "privateBank" } },
            [
              _c(
                "BSelect",
                {
                  staticClass: "is-fullwidth",
                  attrs: {
                    id: "privateBank",
                    placeholder: "Selecciona el tipo de contracto",
                    disabled: _vm.loading,
                    loading: _vm.loading,
                    "is-fullwidth": ""
                  },
                  on: {
                    input: function($event) {
                      return _vm.onInput("bank", $event)
                    }
                  },
                  model: {
                    value: _vm.privateBank,
                    callback: function($$v) {
                      _vm.privateBank = $$v
                    },
                    expression: "privateBank"
                  }
                },
                _vm._l(_vm.bankCatalog, function(option) {
                  return _c(
                    "option",
                    { key: option.value, domProps: { value: option.value } },
                    [
                      _vm._v(
                        "\n            " + _vm._s(option.label) + "\n          "
                      )
                    ]
                  )
                }),
                0
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            {
              attrs: {
                label: "Número de cuenta",
                "label-for": "privateBankAccount"
              }
            },
            [
              _c("BInput", {
                attrs: {
                  id: "privateBankAccount",
                  disabled: _vm.loading,
                  loading: _vm.loading
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("bankAccount", $event)
                  }
                },
                model: {
                  value: _vm.privateBankAccount,
                  callback: function($$v) {
                    _vm.privateBankAccount = $$v
                  },
                  expression: "privateBankAccount"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            {
              attrs: { label: "Salario Base", "label-for": "privateBaseSalary" }
            },
            [
              _c("BInput", {
                attrs: {
                  id: "privateBaseSalary",
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  type: "number",
                  min: "0",
                  step: "0.01"
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("baseSalary", $event)
                  }
                },
                model: {
                  value: _vm.privateBaseSalary,
                  callback: function($$v) {
                    _vm.privateBaseSalary = $$v
                  },
                  expression: "privateBaseSalary"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            {
              attrs: {
                label: "Salario base diario",
                "label-for": "privateDailyBaseSalary"
              }
            },
            [
              _c("BInput", {
                attrs: {
                  id: "privateDailyBaseSalary",
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  type: "number",
                  min: "0",
                  step: "0.01"
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("dailyBaseSalary", $event)
                  }
                },
                model: {
                  value: _vm.privateDailyBaseSalary,
                  callback: function($$v) {
                    _vm.privateDailyBaseSalary = $$v
                  },
                  expression: "privateDailyBaseSalary"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-6 is-12-mobile is-4-widescreen" },
        [
          _c(
            "BField",
            {
              attrs: {
                label: "Clave de entidad federativa",
                "label-for": "privateLocalityKey"
              }
            },
            [
              _c(
                "BSelect",
                {
                  staticClass: "is-fullwidth",
                  attrs: {
                    id: "privateLocalityKey",
                    placeholder: "Selecciona la entidad federativa",
                    disabled: _vm.loading,
                    loading: _vm.loading,
                    "is-fullwidth": ""
                  },
                  on: {
                    input: function($event) {
                      return _vm.onInput("localityKey", $event)
                    }
                  },
                  model: {
                    value: _vm.privateLocalityKey,
                    callback: function($$v) {
                      _vm.privateLocalityKey = $$v
                    },
                    expression: "privateLocalityKey"
                  }
                },
                _vm._l(_vm.localityKeyCatalog, function(option) {
                  return _c(
                    "option",
                    { key: option.value, domProps: { value: option.value } },
                    [
                      _vm._v(
                        "\n            " + _vm._s(option.label) + "\n          "
                      )
                    ]
                  )
                }),
                0
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }